import React, { Fragment } from 'react';
import componentProps, { ComponentProps } from '../../../../helpers/componentProps';
import { generateKeyForElement } from '../../../../helpers/elementKeyHelper';
import { isCardSection, NavLink, SecondaryNavItem } from '../../types';
import withOnClick from '../../withOnClick';
import {
  LinkWrapper,
  MenuContent,
  SectionHeading,
  SectionLinks,
  StyledLink,
  StyledPrimaryCta,
  StyledSecondaryCta,
} from './styles';

type SecondaryNavMenuProps = {
  navItem: SecondaryNavItem;
  resetNav: () => void;
} & ComponentProps;

const SecondaryNavMenu: React.FC<SecondaryNavMenuProps> = ({
  navItem: { sections, primaryCta, secondaryCta },
  resetNav,
  ...props
}) => (
  <MenuContent {...componentProps(props)}>
    {sections.map(
      (navSection) =>
        !isCardSection(navSection) && (
          <Fragment key={generateKeyForElement(navSection)}>
            {navSection.heading && <SectionHeading>{navSection.heading}</SectionHeading>}
            <SectionLinks>
              {navSection.links.map((link: NavLink) => (
                <LinkWrapper key={generateKeyForElement(link)}>
                  <StyledLink
                    removeVisitedStyle
                    href={link.url}
                    onClick={(event) => {
                      resetNav();
                      if (link.onClick) {
                        link.onClick(event);
                      }
                    }}>
                    {link.text}
                  </StyledLink>
                </LinkWrapper>
              ))}
            </SectionLinks>
          </Fragment>
        )
    )}
    {primaryCta && <StyledPrimaryCta cta={withOnClick(primaryCta, resetNav)} />}
    {secondaryCta && <StyledSecondaryCta cta={withOnClick(secondaryCta, resetNav)} />}
  </MenuContent>
);

export default SecondaryNavMenu;
